const Urls = {
	Api: {
		question: function (product_id) {
			return '/my/api/2/product/' + product_id + '/question';
		}
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/product-ask-question/app.html'
	}
};

export default Urls;